import styled from 'foundations-theming/utils';
export const EPNavigationTextColorToken = 'text-core-on-fill-default';
export const EPNavigationItemTextColorToken = 'text-core-default';
export const EPNavigationItemDisabledTextColorToken = 'text-core-disabled';
export const EPNavigationItemHoverBackgroundColorToken = 'global-shell-fill-editortitle-hover';
export const EPNavigationDropdownItemBackgroundColorToken = 'fill-field-hover';
export const EPNavigationDropdownBackgroundColorToken = 'fill-surface-default';
export const EPNavigationDropdownButtonBackgroundColorToken = 'global-shell-fill-editortitle-hover';
export const EPNavigationDropdownBorderColorToken = 'border-core-subtle';
export const topLevelButtonLineHeightToken = '1000';
const getSharedNavigationItemStyles = theme => {
  return Object.assign({
    display: 'flex',
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    textDecoration: 'none',
    transition: 'all 0.15s ease-out',
    // @bend-expect trellis-tokenized
    color: theme.color[EPNavigationTextColorToken],
    borderRadius: theme.borderRadius['100'],
    borderWidth: theme.borderWidth['0'],
    backgroundColor: theme.color['fill-transparent-default'],
    position: 'relative',
    margin: theme.space['0']
  }, theme.typography['heading-50']);
};
export const StyledEPNavigationItemButton = styled.button.withConfig({
  displayName: "EPNavigationStyledButtons__StyledEPNavigationItemButton",
  componentId: "zh2iew-0"
})(({
  $isDisabled,
  $isTopLevel,
  $focusRingStyles,
  href,
  theme
}) => {
  const linkOverrides = href ? {
    // @bend-expect trellis-tokenized
    color: theme.color[EPNavigationItemTextColorToken],
    textDecoration: 'none'
  } : undefined;
  const buttonStylesBasedOnLevel = $isTopLevel ? {
    lineHeight: theme.space[topLevelButtonLineHeightToken],
    padding: `${theme.space['0']} ${theme.space['300']}`,
    color: theme.color[EPNavigationTextColorToken],
    '&:hover, &:focus': {
      // @bend-expect trellis-tokenized
      backgroundColor:
      // @ts-expect-error global-shell tokens aren't in the theme type
      theme.color[EPNavigationItemHoverBackgroundColorToken]
    }
  } : Object.assign({}, theme.typography['body-100'], {
    padding: `${theme.space['200']} ${theme.space['500']}`,
    '&:hover, &:focus': Object.assign({}, linkOverrides, {
      borderRadius: theme.borderRadius['0'],
      // @bend-expect trellis-tokenized
      backgroundColor: theme.color[EPNavigationDropdownItemBackgroundColorToken]
    })
  });
  return Object.assign({}, $focusRingStyles, getSharedNavigationItemStyles(theme), {
    cursor: $isDisabled ? 'not-allowed' : 'pointer',
    color: $isDisabled ?
    // @bend-expect trellis-tokenized
    theme.color[EPNavigationItemDisabledTextColorToken] :
    // @bend-expect trellis-tokenized
    theme.color[EPNavigationItemTextColorToken]
  }, buttonStylesBasedOnLevel, {
    whiteSpace: 'nowrap'
  });
});
export const StyledEPNavigationDropdownButton = styled.button.withConfig({
  displayName: "EPNavigationStyledButtons__StyledEPNavigationDropdownButton",
  componentId: "zh2iew-1"
})(({
  $isActive,
  $focusRingStyles,
  theme
}) => {
  return Object.assign({}, $focusRingStyles, getSharedNavigationItemStyles(theme), {
    // @bend-expect trellis-tokenized
    lineHeight: theme.space[topLevelButtonLineHeightToken],
    padding: `${theme.space['0']} ${theme.space['200']} ${theme.space['0']} ${theme.space['0']}`
  }, $isActive && {
    // @bend-expect trellis-tokenized
    backgroundColor:
    // @ts-expect-error global-shell tokens aren't in the theme type
    theme.color[EPNavigationDropdownButtonBackgroundColorToken]
  }, {
    '&:hover': {
      // @bend-expect trellis-tokenized
      backgroundColor:
      // @ts-expect-error global-shell tokens aren't in the theme type
      theme.color[EPNavigationDropdownButtonBackgroundColorToken]
    },
    whiteSpace: 'nowrap'
  });
});